import { Autocomplete, Chip, TextField } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";

const DiagnosisSearchAndSelect = ({ label, diagnosis, setDiagnosis }) => {
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState(diagnosis);
  const apiUrl = "https://clinicaltables.nlm.nih.gov/api/conditions/v3/search";

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const handleSelect = (e, newValue) => {
    setSelectedValues(newValue);
    setSearchValue("");
    setDiagnosis(newValue);
  };

  useEffect(() => {
    const DiagnoseSearchOptions = async () => {
      if (!searchValue.trim()) {
        return;
      }
      try {
        const res = await axios.get(apiUrl, {
          params: { terms: searchValue },
        });
        if (res?.data) {
          const responseText = res.data;
          const responseOption = responseText[3].map((item) => item[0]);
          setOptions(responseOption);
        }
      } catch (error) {}
    };
    DiagnoseSearchOptions();
  }, [searchValue]);

  useEffect(() => {
    if (diagnosis) {
      setSelectedValues(diagnosis);
    } else {
      setSelectedValues([]);
    }
  }, [diagnosis]);

  return (
    <Autocomplete
      multiple
      disablePortal
      onInputChange={handleChange}
      onChange={handleSelect}
      value={selectedValues}
      noOptionsText={searchValue?.length ? "No Options" : "Type to search"}
      options={Array.isArray(options) ? options : []}
      renderInput={(params) => <TextField {...params} label={label} />}
      renderTags={(selected, getProps) =>
        Array.isArray(selected)
          ? selected.map((option, index) => (
              <Chip label={option} {...getProps({ index })} key={index} />
            ))
          : []
      }
      className="add-edit-patient-search-select preference-attribute-select"
    />
  );
};

export default DiagnosisSearchAndSelect;
